<div class="main-content table-page table-page--compact incidencias-board-page incidencias-host-page">
  <div class="container-fluid">
    <section class="table-page__card">
      <div class="incidencias-board-page__toolbar-anchor">
        <div class="table-page__toolbar table-page__toolbar--filters">
          <div class="table-page__filters-grid incidencias-board-page__filters-grid"></div>

          <div class="incidencias-board-page__toolbar-actions">
            <label class="table-page__page-size incidencias-board-page__page-size">
              <span>Registros por página</span>
              <select [ngModel]="itemsPerPage" (ngModelChange)="onItemsPerPageChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>

            <button type="button" mat-raised-button class="btn table-page__icon-btn incidencias-board-page__toolbar-btn"
              (click)="abrirNueva()">
              <i class="material-icons">add</i>
              <span>Nueva</span>
            </button>

            <button type="button" mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
              (click)="catalogoOpen = !catalogoOpen">
              <i class="material-icons">tune</i>
              <span>Servicios</span>
            </button>

            <button type="button" mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
              (click)="refrescarTodas()">
              <i class="material-icons">refresh</i>
              <span>Actualizar</span>
            </button>

            <button type="button" mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
              (click)="filtersPopupOpen = !filtersPopupOpen">
              <i class="material-icons">filter_alt</i>
              <span>Filtros</span>
              <strong class="incidencias-board-page__toolbar-badge" *ngIf="getActiveFiltersCount() > 0">
                {{ getActiveFiltersCount() }}
              </strong>
            </button>

            <div class="incidencias-board-page__toolbar-summary">
              <span>Total</span>
              <strong>{{ totalItems }}</strong>
            </div>
          </div>
        </div>

        <div class="alert alert-danger incidencias-host-page__load-alert" *ngIf="errorCarga">
          <i class="material-icons">error_outline</i>
          <span>{{ errorCarga }}</span>
        </div>

        <div class="incidencias-board-page__filters-popover is-open" *ngIf="filtersPopupOpen">
          <div class="incidencias-board-page__filters-dialog">
            <div class="incidencias-board-page__filters-dialog-header">
              <div>
            <h3>Filtros de Incidencias Hosting</h3>
              </div>
            </div>

            <div class="incidencias-board-page__filters-panel">
              <div class="row incidencias-host-page__filters-grid">
                <div class="col-12 col-md-3">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>No. reporte</mat-label>
                    <input matInput aria-label="No. reporte" type="number" min="1" [(ngModel)]="filtros.idIncidenciaHost" />
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-3">
                  <mat-form-field appearance="outline" class="table-page__field incidencias-host-page__date-field">
                    <mat-label>Fecha inicio desde</mat-label>
                    <input matInput aria-label="Fecha inicio desde" [matDatepicker]="filtroPickerDesde" [(ngModel)]="filtros.fechaInicioDesde"
                      (click)="toggleDatepicker(filtroPickerDesde, $event)" />
                    <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario"
                      (click)="toggleDatepicker(filtroPickerDesde, $event)">
                      <mat-icon>calendar_today</mat-icon>
                    </button>
                    <mat-datepicker #filtroPickerDesde panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-3">
                  <mat-form-field appearance="outline" class="table-page__field incidencias-host-page__date-field">
                    <mat-label>Fecha inicio hasta</mat-label>
                    <input matInput aria-label="Fecha inicio hasta" [matDatepicker]="filtroPickerHasta" [(ngModel)]="filtros.fechaInicioHasta"
                      (click)="toggleDatepicker(filtroPickerHasta, $event)" />
                    <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario"
                      (click)="toggleDatepicker(filtroPickerHasta, $event)">
                      <mat-icon>calendar_today</mat-icon>
                    </button>
                    <mat-datepicker #filtroPickerHasta panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-3">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Prioridad</mat-label>
                    <mat-select #filtroPrioridadSelect [(ngModel)]="filtros.prioridad" panelClass="incidencia-host-select-panel"
                      (mousedown)="cerrarSelectSiAbierto($event, filtroPrioridadSelect)">
                      <mat-option [value]="null">Todas</mat-option>
                      <mat-option *ngFor="let option of prioridadOptions" [value]="option.value">{{ option.label }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-4">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Severidad</mat-label>
                    <mat-select #filtroSeveridadSelect [(ngModel)]="filtros.severidad" panelClass="incidencia-host-select-panel"
                      (mousedown)="cerrarSelectSiAbierto($event, filtroSeveridadSelect)">
                      <mat-option [value]="null">Todas</mat-option>
                      <mat-option *ngFor="let option of severidadOptions" [value]="option.value">{{ option.label }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-4">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Cliente afectado</mat-label>
                    <mat-select #filtroClienteSelect multiple [(ngModel)]="filtros.idsClientes"
                      (ngModelChange)="onClientesFiltroChange($event)"
                      (selectionChange)="cerrarClienteDespuesDeSeleccionar(filtroClienteSelect, $event)"
                      [panelClass]="['incidencia-host-select-panel', 'incidencia-host-cliente-select-panel']"
                      (mousedown)="cerrarSelectSiAbierto($event, filtroClienteSelect)">
                      <mat-select-trigger>{{ textoClientes(filtros) || "Todos los clientes" }}</mat-select-trigger>
                      <mat-option [value]="clienteTodosValor">Todos los clientes</mat-option>
                      <mat-option>
                        <ngx-mat-select-search [formControl]="busquedaClienteFiltro"
                          [placeholderLabel]="'Buscar cliente'" [noEntriesFoundLabel]="'No existe cliente'">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let cliente of clientesFiltro" [value]="cliente.id">
                        {{ cliente.razonsocial }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-4">
                  <mat-form-field appearance="outline" class="table-page__field">
                    <mat-label>Tipo de reporte</mat-label>
                    <mat-select #filtroTipoSelect [(ngModel)]="filtros.idTipoServicio" panelClass="incidencia-host-select-panel"
                      (mousedown)="cerrarSelectSiAbierto($event, filtroTipoSelect)">
                      <mat-option [value]="null">Todos</mat-option>
                      <mat-option *ngFor="let tipo of tiposServicio" [value]="tipo.idTipoServicioHost">
                        {{ tipo.tipoServicio }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-4">
                  <mat-checkbox [(ngModel)]="filtros.fueraServicio">Fuera de servicio</mat-checkbox>
                </div>
              </div>
            </div>

            <div class="incidencias-board-page__filters-dialog-actions">
              <button type="button" mat-raised-button
                class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
                (click)="limpiarFiltros()">
                <i class="material-icons">filter_alt_off</i>
                <span>Limpiar</span>
              </button>
              <button type="button" mat-raised-button
                class="btn table-page__icon-btn incidencias-board-page__toolbar-btn" (click)="aplicarFiltros()">
                <i class="material-icons">done</i>
                <span>Aplicar</span>
              </button>
            </div>
          </div>
        </div>

        <div class="incidencias-host-page__catalog" *ngIf="catalogoOpen">
          <div class="incidencias-host-page__catalog-form">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Tipo de servicio</mat-label>
              <input matInput aria-label="Tipo de servicio" maxlength="120" [(ngModel)]="tipoServicioForm.tipoServicio" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Clave</mat-label>
              <input matInput aria-label="Clave" maxlength="40" [ngModel]="tipoServicioForm.clave" (ngModelChange)="onClaveServicioChange($event)" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Tiempo mínimo</mat-label>
              <input matInput aria-label="Tiempo mínimo" type="number" min="0" [(ngModel)]="tipoServicioForm.tiempoMinimoMin" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Tiempo máximo</mat-label>
              <input matInput aria-label="Tiempo máximo" type="number" min="0" [(ngModel)]="tipoServicioForm.tiempoMaximoMin" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Máximo incidente</mat-label>
              <input matInput aria-label="Máximo incidente" type="number" min="0" [(ngModel)]="tipoServicioForm.tiempoMaximoIncidenteMin" />
            </mat-form-field>
            <mat-checkbox [(ngModel)]="tipoServicioForm.activo">Activo</mat-checkbox>
            <button type="button" mat-raised-button class="btn table-page__icon-btn incidencias-board-page__toolbar-btn"
              (click)="guardarTipoServicio()">
              <i class="material-icons">save</i>
              <span>Guardar</span>
            </button>
          </div>

          <div class="incidencias-host-page__catalog-list">
            <button type="button" *ngFor="let tipo of tiposServicio; trackBy: trackByTipo" (click)="editarTipoServicio(tipo)">
              <strong>{{ tipo.tipoServicio }}</strong>
              <span>{{ tipo.clave }}</span>
              <small>{{ tipo.tiempoMinimoMin }} / {{ tipo.tiempoMaximoMin }} / {{ tipo.tiempoMaximoIncidenteMin }} min</small>
            </button>
          </div>
        </div>
      </div>

      <div class="incidencias-host-page__workspace">
        <div class="incidencias-board-page__board-shell">
          <div class="incidencias-board-page__board">
            <article class="incidencias-board-page__column" *ngFor="let column of columns; trackBy: trackByEstado"
              [style.--incidencia-column-color]="column.color">
              <header class="incidencias-board-page__column-header" [style.backgroundColor]="column.color">
                <div class="incidencias-board-page__column-title">
                  <span class="material-icons">{{ column.icon }}</span>
                  <div class="incidencias-board-page__column-title-text">
                    <strong>{{ column.titulo }}</strong>
                    <small>{{ column.totalItems }}</small>
                  </div>
                </div>
              </header>

              <div class="incidencias-board-page__column-pager" *ngIf="column.totalItems > 0">
                <div class="table-page__pager incidencias-board-page__pager">
                  <span class="incidencias-host-page__pager-summary">
                    {{ column.currentPage }}/{{ column.totalPages || 1 }}
                  </span>
                  <button type="button" class="table-page__pager-link" (click)="firstPage(column)" [disabled]="column.currentPage <= 1">&laquo;</button>
                  <button type="button" class="table-page__pager-link" (click)="previousPage(column)" [disabled]="column.currentPage <= 1">&lsaquo;</button>
                  <ng-container *ngFor="let page of getPaginationItems(column)">
                    <button
                      *ngIf="isPageNumber(page); else ellipsisTpl"
                      type="button"
                      class="table-page__pager-page"
                      [class.is-current]="page === column.currentPage"
                      (click)="pageChanged(column, page)">
                      {{ page }}
                    </button>
                  </ng-container>
                  <ng-template #ellipsisTpl>
                    <span class="table-page__pager-ellipsis">...</span>
                  </ng-template>
                  <button type="button" class="table-page__pager-link" (click)="nextPage(column)" [disabled]="column.currentPage >= column.totalPages">&rsaquo;</button>
                  <button type="button" class="table-page__pager-link" (click)="lastPage(column)" [disabled]="column.currentPage >= column.totalPages">&raquo;</button>
                </div>
              </div>

              <div class="incidencias-board-page__column-body">
                <div class="table-page__empty-state incidencias-host-page__empty-column" *ngIf="!column.loading && !column.items.length">
                  <mat-icon>event_busy</mat-icon>
                  <p>Sin incidencias en {{ column.titulo }}.</p>
                </div>

                <button type="button" class="incidencias-host-card" *ngFor="let incidencia of column.items; trackBy: trackByIncidencia"
                  [class.is-outage]="incidencia.fueraServicio && incidencia.estadoEvento !== 'VOBO'"
                  (click)="seleccionar(incidencia)">
                  <span class="incidencias-host-card__stripe" [style.backgroundColor]="column.color"></span>
                  <span class="incidencias-host-card__header">
                    <strong>#{{ incidencia.idIncidenciaHost }}</strong>
                    <small>{{ formatDate(incidencia.fechaInicio) }}</small>
                  </span>
                  <span class="incidencias-host-card__title">{{ tituloTarjeta(incidencia) }}</span>
                  <span class="incidencias-host-card__description">{{ incidencia.soporte || "Sin descripción" }}</span>
                  <span class="incidencias-host-card__chips">
                    <em>{{ incidencia.prioridad || "-" }}</em>
                    <em>{{ incidencia.severidad || "-" }}</em>
                    <em *ngIf="incidencia.fueraServicio">Fuera de servicio</em>
                  </span>
                  <span class="incidencias-host-card__footer">
                    <span>SLA atención: {{ incidencia.slaAtencion === false ? "No" : "Sí" }}</span>
                    <span class="incidencias-host-card__footer-spacer"></span>
                  </span>
                </button>
              </div>
            </article>
          </div>
        </div>

        <ng-template #hostDetailDialog>
          <section class="incidencias-host-page__panel incidencias-host-page__modal-panel" *ngIf="selected">
            <header class="incidencias-host-page__modal-header" [style.backgroundColor]="estadoColor(selected.estadoEvento)">
              <div class="incidencias-host-page__modal-title">
                <h3>
                  <mat-icon>{{ estadoIcono(selected.estadoEvento) }}</mat-icon>
                  <span>Reporte #{{ selected.idIncidenciaHost }}</span>
                </h3>
                <p>{{ estadoTitulo(selected.estadoEvento) }}</p>
              </div>
              <div class="incidencias-host-page__panel-actions">
                <button type="button" mat-icon-button (click)="cerrarPanel()">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </header>

            <div class="incidencias-host-page__summary incidencias-host-page__summary--editable">
              <div class="incidencias-host-page__form-grid incidencias-host-page__form-grid--detail">
                <mat-form-field appearance="outline" class="incidencias-host-page__field--quarter incidencias-host-page__date-field">
                  <mat-label>Fecha inicio</mat-label>
                  <input matInput aria-label="Fecha inicio" [matDatepicker]="detallePickerInicio" [(ngModel)]="form.fechaInicio" [disabled]="soloLectura"
                    (click)="toggleDatepicker(detallePickerInicio, $event)" />
                  <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario" [disabled]="soloLectura"
                    (click)="toggleDatepicker(detallePickerInicio, $event)">
                    <mat-icon>calendar_today</mat-icon>
                  </button>
                  <mat-datepicker #detallePickerInicio panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="incidencias-host-page__field--quarter">
                  <mat-label>Hora inicio</mat-label>
                  <input matInput aria-label="Hora inicio" type="time" [(ngModel)]="formFechaInicioHora" [disabled]="soloLectura" />
                </mat-form-field>

                <mat-form-field *ngIf="mostrarFechaInicioAtencionFormulario" appearance="outline" class="incidencias-host-page__field--quarter incidencias-host-page__date-field">
                  <mat-label>Fecha inicio de atención</mat-label>
                  <input matInput aria-label="Fecha inicio de atención" [matDatepicker]="detallePickerInicioAtencion" [(ngModel)]="form.fechaInicioAtencion" [disabled]="soloLectura"
                    (click)="toggleDatepicker(detallePickerInicioAtencion, $event)" />
                  <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario" [disabled]="soloLectura"
                    (click)="toggleDatepicker(detallePickerInicioAtencion, $event)">
                    <mat-icon>calendar_today</mat-icon>
                  </button>
                  <mat-datepicker #detallePickerInicioAtencion panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
                </mat-form-field>

                <mat-form-field *ngIf="mostrarFechaInicioAtencionFormulario" appearance="outline" class="incidencias-host-page__field--quarter">
                  <mat-label>Hora inicio de atención</mat-label>
                  <input matInput aria-label="Hora inicio de atención" type="time" [(ngModel)]="formFechaInicioAtencionHora" [disabled]="soloLectura" />
                </mat-form-field>

                <mat-form-field *ngIf="mostrarFechaFinFormulario" appearance="outline" class="incidencias-host-page__field--quarter incidencias-host-page__date-field">
                  <mat-label>Fecha fin</mat-label>
                  <input matInput aria-label="Fecha fin" [matDatepicker]="detallePickerFin" [(ngModel)]="form.fechaFin" [disabled]="soloLectura"
                    (click)="toggleDatepicker(detallePickerFin, $event)" />
                  <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario" [disabled]="soloLectura"
                    (click)="toggleDatepicker(detallePickerFin, $event)">
                    <mat-icon>calendar_today</mat-icon>
                  </button>
                  <mat-datepicker #detallePickerFin panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
                </mat-form-field>

                <mat-form-field *ngIf="mostrarFechaFinFormulario" appearance="outline" class="incidencias-host-page__field--quarter">
                  <mat-label>Hora fin</mat-label>
                  <input matInput aria-label="Hora fin" type="time" [(ngModel)]="formFechaFinHora" [disabled]="soloLectura" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="incidencias-host-page__field--quarter">
                  <mat-label>Prioridad</mat-label>
                  <mat-select #detallePrioridadSelect [(ngModel)]="form.prioridad" [disabled]="soloLectura || form.fueraServicio" panelClass="incidencia-host-select-panel"
                    (mousedown)="cerrarSelectSiAbierto($event, detallePrioridadSelect)">
                    <mat-option *ngFor="let option of prioridadOptions" [value]="option.value">{{ option.label }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="incidencias-host-page__field--quarter">
                  <mat-label>N. severidad</mat-label>
                  <mat-select #detalleSeveridadSelect [(ngModel)]="form.severidad" [disabled]="soloLectura || form.fueraServicio" panelClass="incidencia-host-select-panel"
                    (mousedown)="cerrarSelectSiAbierto($event, detalleSeveridadSelect)">
                    <mat-option *ngFor="let option of severidadOptions" [value]="option.value">{{ option.label }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="incidencias-host-page__field--third">
                  <mat-label>Tipo de reporte</mat-label>
                  <mat-select #detalleTipoSelect [(ngModel)]="form.idTipoServicio" (ngModelChange)="onTipoServicioChange()" [disabled]="tipoReporteDetalleBloqueado()" panelClass="incidencia-host-select-panel"
                    (mousedown)="cerrarSelectSiAbierto($event, detalleTipoSelect)">
                    <mat-option *ngFor="let tipo of tiposReporteDisponibles" [value]="tipo.idTipoServicioHost">{{ etiquetaTipoReporte(tipo.clave) }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="incidencias-host-page__field--third">
                  <mat-label>Cliente afectado</mat-label>
                  <input matInput aria-label="Cliente afectado bloqueado después de crear" [value]="textoClientes()" [disabled]="true" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="incidencias-host-page__field--third">
                  <mat-label>Área Coordinador</mat-label>
                  <mat-select #areaResponsableSelect [(ngModel)]="form.idAreaResponsable" [disabled]="true" panelClass="incidencia-host-select-panel"
                    (mousedown)="cerrarSelectSiAbierto($event, areaResponsableSelect)">
                    <mat-option *ngFor="let area of areas" [value]="area.id">{{ area.area }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="incidencias-host-page__field--third">
                  <mat-label>Coordinador</mat-label>
                  <mat-select #responsableActualSelect [(ngModel)]="form.idEmpleadoResponsable" [disabled]="true" panelClass="incidencia-host-select-panel"
                    (mousedown)="cerrarSelectSiAbierto($event, responsableActualSelect)">
                    <mat-option *ngFor="let empleado of responsables" [value]="empleado.idEmpleado">
                      {{ nombreEmpleado(empleado) }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="incidencias-host-page__textarea">
                  <mat-label>Soporte</mat-label>
                  <textarea matInput aria-label="Soporte" rows="3" maxlength="500" [(ngModel)]="form.soporte" [disabled]="soloLectura"></textarea>
                </mat-form-field>

              </div>

              <div class="incidencias-host-page__computed">
                <span>Rango atención: <strong>{{ minutosLabel(form.rangoAtencionMin) }}</strong></span>
                <span>SLA atención: <strong>{{ form.slaAtencion === false ? "No" : "Sí" }}</strong></span>
                <span>SLA continuidad: <strong>{{ form.slaContinuidad | percent: "1.2-4" }}</strong></span>
                <div class="incidencias-host-page__computed-item incidencias-host-page__computed-item--checkbox">
                  <mat-checkbox [(ngModel)]="form.fueraServicio" (change)="onFueraServicioChange($event)" [disabled]="soloLectura || selected.estadoEvento === 'ATENDIDO'">Fuera de servicio</mat-checkbox>
                  <strong *ngIf="form.fueraServicio">{{ tiempoFueraServicioVisible() }}</strong>
                </div>
              </div>

            </div>

            <div class="incidencias-host-page__actions incidencias-host-page__actions--modal">
              <button type="button" mat-raised-button
                class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
                (click)="abrirActividades()">
                <i class="material-icons">list_alt</i>
                <span>Actividades</span>
              </button>
              <button *ngIf="mostrarResumenFueraServicio" type="button" mat-raised-button
                class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
                (click)="abrirResumenFueraServicio()">
                <i class="material-icons">warning_amber</i>
                <span>Fuera de servicio</span>
              </button>
              <span class="incidencias-host-page__actions-spacer"></span>
              <button type="button" mat-button class="btn btn-success" (click)="guardarIncidencia()" [disabled]="soloLectura">
                Guardar <i class="material-icons">save</i>
              </button>
              <button *ngIf="puedeEditarFlujo() && siguienteEstado(selected.estadoEvento)" type="button" mat-raised-button
                class="btn table-page__icon-btn incidencias-board-page__toolbar-btn" (click)="abrirTransicionDialog()">
                <i class="material-icons">published_with_changes</i>
                <span>{{ labelEstadoSiguiente(selected.estadoEvento) }}</span>
              </button>
              <button *ngIf="selected.estadoEvento === 'ATENDIDO'" type="button" mat-raised-button
                class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
                (click)="abrirRegresoAProcesoDialog()">
                <i class="material-icons">undo</i>
                <span>Regresar a proceso</span>
              </button>
              <button mat-button class="btn btn-danger" type="button" (click)="cerrarPanel()">
                <i class="fa fa-times-circle-o"></i> Cerrar
              </button>
            </div>

            <div class="incidencias-host-page__detail-form" *ngIf="false && puedeEditarFlujo()">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Fecha/Hora</mat-label>
                <input matInput aria-label="Fecha/Hora" type="datetime-local" [(ngModel)]="detalleForm.fechaActividad" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Área</mat-label>
                <mat-select #detalleAreaSelect [(ngModel)]="detalleForm.idArea" panelClass="incidencia-host-select-panel"
                  (mousedown)="cerrarSelectSiAbierto($event, detalleAreaSelect)">
                  <mat-option *ngFor="let area of areas" [value]="area.id">{{ area.area }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Responsable</mat-label>
                <mat-select #detalleResponsableSelect [(ngModel)]="detalleForm.idEmpleadoResponsable" panelClass="incidencia-host-select-panel"
                  (mousedown)="cerrarSelectSiAbierto($event, detalleResponsableSelect)">
                  <mat-option *ngFor="let empleado of responsables" [value]="empleado.idEmpleado">
                    {{ nombreEmpleado(empleado) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="table-page__field incidencias-host-page__textarea">
                <mat-label>Actividad</mat-label>
                <textarea matInput aria-label="Actividad" rows="3" maxlength="250" [(ngModel)]="detalleForm.actividad"></textarea>
              </mat-form-field>
              <button type="button" mat-raised-button class="btn table-page__icon-btn incidencias-board-page__toolbar-btn"
                (click)="guardarDetalle()">
                <i class="material-icons">add_task</i>
                <span>Agregar</span>
              </button>
            </div>

            <div class="incidencias-host-page__transition" *ngIf="false && puedeEditarFlujo() && siguienteEstado(selected.estadoEvento)">
              <mat-form-field appearance="outline" class="table-page__field incidencias-host-page__textarea">
                <mat-label>Comentario para {{ labelEstadoSiguiente(selected.estadoEvento) }}</mat-label>
                <textarea matInput [attr.aria-label]="'Comentario para ' + labelEstadoSiguiente(selected.estadoEvento)" rows="3" maxlength="500" [(ngModel)]="comentarioTransicion"></textarea>
              </mat-form-field>
              <input *ngIf="siguienteEstado(selected.estadoEvento) === 'VOBO'" type="file" multiple aria-label="Elegir archivos" (change)="onArchivosTransicion($event)" />
              <button type="button" mat-raised-button class="btn table-page__icon-btn incidencias-board-page__toolbar-btn"
                (click)="cambiarEstado(selected)">
                <i class="material-icons">published_with_changes</i>
                <span>{{ labelEstadoSiguiente(selected.estadoEvento) }}</span>
              </button>
              <button *ngIf="selected.estadoEvento === 'ATENDIDO'" type="button" mat-raised-button
                class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
                (click)="regresarAProceso()">
                <i class="material-icons">undo</i>
                <span>Regresar a proceso</span>
              </button>
            </div>
          </section>
        </ng-template>
      </div>
    </section>
  </div>
</div>

<div class="incidencias-host-success-toast" *ngIf="exitoTemporal" role="status" aria-live="polite">
  <mat-icon>check_circle</mat-icon>
  <span>{{ exitoTemporal }}</span>
</div>

<div class="incidencias-host-error-toast" *ngIf="errorEmergente" role="alert" aria-live="assertive">
  <mat-icon>error_outline</mat-icon>
  <span>{{ errorEmergente }}</span>
  <button mat-icon-button type="button" aria-label="Cerrar aviso" (click)="cerrarErrorEmergente()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="incidencias-host-modal-overlay" *ngIf="detailOpen && selected" (click)="cerrarPanel()" (keydown.enter)="$event.target === $event.currentTarget ? cerrarPanel() : null">
  <div class="incidencias-host-modal-shell incidencias-host-modal-shell--detail" role="dialog" aria-modal="true"
    aria-label="Detalle de incidencia Hosting" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <ng-container *ngTemplateOutlet="hostDetailDialog"></ng-container>
  </div>
</div>

<div class="incidencias-host-modal-overlay incidencias-host-modal-overlay--secondary" *ngIf="actividadesOpen && selected" (click)="cerrarActividades()" (keydown.enter)="$event.target === $event.currentTarget ? cerrarActividades() : null">
  <section class="incidencias-host-secondary-modal incidencias-host-secondary-modal--wide" role="dialog" aria-modal="true"
    aria-label="Actividades de incidencia Hosting" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <header class="incidencias-host-page__modal-header" [style.backgroundColor]="estadoColor(selected.estadoEvento)">
      <div class="incidencias-host-page__modal-title">
        <h3>
          <mat-icon>list_alt</mat-icon>
          <span>Actividades #{{ selected.idIncidenciaHost }}</span>
        </h3>
        <p>Historial de actividades y comentarios</p>
      </div>
      <button type="button" mat-icon-button (click)="cerrarActividades()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="incidencias-host-secondary-modal__body">
      <div class="incidencias-host-page__actions incidencias-host-page__actions--toolbar">
        <button type="button" mat-raised-button class="btn table-page__icon-btn incidencias-board-page__toolbar-btn"
          (click)="abrirNuevaActividad()" [disabled]="soloLectura">
          <i class="material-icons">add_task</i>
          <span>Añadir nueva actividad</span>
        </button>
      </div>

      <div class="incidencias-host-page__activity-table-wrap">
        <table class="incidencias-host-page__activity-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Área</th>
              <th>Responsable</th>
              <th>Actividad</th>
              <th>Comentarios</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let detalle of actividadesOrdenadas(); trackBy: trackByDetalle">
              <td>{{ detalle.fechaActividad | date: "dd/MM/yyyy" }}</td>
              <td>{{ detalle.fechaActividad | date: "HH:mm" }}</td>
              <td>{{ detalle.area || "Sin área" }}</td>
              <td>{{ detalle.responsable || "Sin responsable" }}</td>
              <td>{{ detalle.actividad || "-" }}</td>
              <td>
                <button type="button" mat-button (click)="verComentarios(detalle)">
                  Ver comentarios
                </button>
              </td>
              <td>
                <button type="button" mat-button *ngIf="!soloLectura && puedeEditarActividad(detalle)"
                  (click)="abrirEditarActividad(detalle)">
                  Editar
                </button>
              </td>
            </tr>
            <tr *ngIf="!detalles.length">
              <td colspan="7" class="incidencias-host-page__table-empty">Sin actividades registradas.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</div>

<div class="incidencias-host-modal-overlay incidencias-host-modal-overlay--third" *ngIf="actividadFormOpen && selected" (click)="cerrarNuevaActividad()" (keydown.enter)="$event.target === $event.currentTarget ? cerrarNuevaActividad() : null">
  <section class="incidencias-host-secondary-modal" role="dialog" aria-modal="true"
    [attr.aria-label]="(actividadEditando ? 'Editar' : 'Nueva') + ' actividad de incidencia Hosting'" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <header class="incidencias-host-page__modal-header" [style.backgroundColor]="estadoColor(selected.estadoEvento)">
      <div class="incidencias-host-page__modal-title">
        <h3>
          <mat-icon>{{ actividadEditando ? "edit" : "add_task" }}</mat-icon>
          <span>{{ actividadEditando ? "Editar actividad" : "Nueva actividad" }}</span>
        </h3>
        <p>{{ actividadEditando ? "Modifica fecha, responsable o actividad realizada." : "Registra fecha, responsable y actividad realizada." }}</p>
      </div>
      <button type="button" mat-icon-button (click)="cerrarNuevaActividad()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="incidencias-host-secondary-modal__body incidencias-host-page__form-grid">
      <mat-form-field appearance="outline" class="incidencias-host-page__field--half incidencias-host-page__date-field">
        <mat-label>Fecha</mat-label>
        <input matInput aria-label="Fecha" [matDatepicker]="actividadPicker" [(ngModel)]="actividadFecha"
          (click)="toggleDatepicker(actividadPicker, $event)" />
        <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario"
          (click)="toggleDatepicker(actividadPicker, $event)">
          <mat-icon>calendar_today</mat-icon>
        </button>
        <mat-datepicker #actividadPicker panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="incidencias-host-page__field--half">
        <mat-label>Hora</mat-label>
        <input matInput aria-label="Hora" type="time" [(ngModel)]="actividadHora" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="incidencias-host-page__field--half">
        <mat-label>Área</mat-label>
        <mat-select #actividadAreaSelect [(ngModel)]="detalleForm.idArea" panelClass="incidencia-host-select-panel"
          (selectionChange)="onAreaActividadChange()"
          (mousedown)="cerrarSelectSiAbierto($event, actividadAreaSelect)">
          <mat-option>
            <ngx-mat-select-search [formControl]="busquedaAreaActividad"
              [placeholderLabel]="'Buscar área'" [noEntriesFoundLabel]="'No existe área'">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let area of areasActividadFiltradas" [value]="area.id">{{ area.area }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="incidencias-host-page__field--half">
        <mat-label>Responsable</mat-label>
        <mat-select #actividadResponsableSelect [(ngModel)]="detalleForm.idEmpleadoResponsable" panelClass="incidencia-host-select-panel"
          (selectionChange)="onTrabajadorActividadChange()"
          (mousedown)="cerrarSelectSiAbierto($event, actividadResponsableSelect)">
          <mat-option>
            <ngx-mat-select-search [formControl]="busquedaTrabajadorActividad"
              [placeholderLabel]="'Buscar responsable activo'" [noEntriesFoundLabel]="'No existe responsable activo'">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let empleado of trabajadoresActividadFiltrados" [value]="empleado.idEmpleado">
            {{ nombreEmpleado(empleado) }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="incidencias-host-page__textarea">
        <mat-label>Actividad</mat-label>
        <textarea matInput aria-label="Actividad" rows="4" maxlength="250" [(ngModel)]="detalleForm.actividad"></textarea>
      </mat-form-field>
    </div>

    <footer class="incidencias-host-secondary-modal__footer">
      <button mat-button class="btn btn-danger" type="button" (click)="cerrarNuevaActividad()">
        <i class="fa fa-times-circle-o"></i> Cancelar
      </button>
      <button mat-button type="button" class="btn btn-success" (click)="guardarDetalle()">
        Guardar <i class="material-icons">save</i>
      </button>
    </footer>
  </section>
</div>

<div class="incidencias-host-modal-overlay incidencias-host-modal-overlay--third" *ngIf="comentariosDetalle" (click)="cerrarComentarios()" (keydown.enter)="$event.target === $event.currentTarget ? cerrarComentarios() : null">
  <section class="incidencias-host-secondary-modal" role="dialog" aria-modal="true"
    aria-label="Comentarios de actividad" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <header class="incidencias-host-page__modal-header" [style.backgroundColor]="'#2563eb'">
      <div class="incidencias-host-page__modal-title">
        <h3>
          <mat-icon>comment</mat-icon>
          <span>Comentarios</span>
        </h3>
        <p>{{ comentariosDetalle.actividad || "Actividad" }}</p>
      </div>
      <button type="button" mat-icon-button (click)="cerrarComentarios()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="incidencias-host-secondary-modal__body">
      <div class="incidencias-host-page__comments">
        <div class="incidencias-host-page__comment" *ngFor="let comentario of comentariosOrdenados(comentariosDetalle); trackBy: trackByComentario">
          <div class="incidencias-host-page__comment-header">
            <div class="incidencias-host-page__comment-assignment">
              <span>Área: {{ areaComentario(comentario, comentariosDetalle) }}</span>
              <span>Responsable: {{ responsableComentario(comentario, comentariosDetalle) }}</span>
              <span *ngIf="comentario.tipoAdicional && !comentario.editando">Tipo adicional: {{ etiquetaTipoReporte(comentario.tipoAdicional) }}</span>
            </div>
            <span>{{ comentario.fechaModificacion | date: "dd/MM/yyyy HH:mm" }}</span>
          </div>
          <textarea *ngIf="comentario.editando" aria-label="Comentario" [(ngModel)]="comentario.comentario" maxlength="500"></textarea>
          <p *ngIf="!comentario.editando">{{ comentario.comentario }}</p>
          <div class="incidencias-host-page__comment-edit-fields" *ngIf="comentario.editando">
            <mat-form-field appearance="outline">
              <mat-label>Área</mat-label>
              <mat-select #comentarioAreaSelect [(ngModel)]="comentario.idArea" panelClass="incidencia-host-select-panel"
                (mousedown)="cerrarSelectSiAbierto($event, comentarioAreaSelect)">
                <mat-option *ngFor="let area of areas" [value]="area.id">{{ area.area }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Responsable</mat-label>
              <mat-select #comentarioResponsableSelect [(ngModel)]="comentario.idEmpleadoResponsable"
                panelClass="incidencia-host-select-panel"
                (mousedown)="cerrarSelectSiAbierto($event, comentarioResponsableSelect)">
                <mat-option *ngFor="let empleado of responsables" [value]="empleado.idEmpleado">{{ nombreEmpleado(empleado) }}</mat-option>
              </mat-select>
            </mat-form-field>

            <label class="incidencias-host-page__comment-date-field">
              Fecha y hora
              <input type="datetime-local" [ngModel]="toDateTimeLocal(comentario.fechaModificacion)"
                (ngModelChange)="actualizarFechaComentario(comentario, $event)" />
            </label>

            <div class="incidencias-host-page__tipo-adicional">
              <mat-checkbox [(ngModel)]="comentario.conTipoAdicional">Tipo adicional</mat-checkbox>
              <mat-form-field appearance="outline">
                <mat-label>Tipo de servicio</mat-label>
                <mat-select #comentarioTipoSelect [(ngModel)]="comentario.idTipoServicioAdicional" [disabled]="!comentario.conTipoAdicional"
                  panelClass="incidencia-host-select-panel" (mousedown)="cerrarSelectSiAbierto($event, comentarioTipoSelect)">
                  <mat-option *ngFor="let tipo of tiposReporteDisponibles" [value]="tipo.idTipoServicioHost">{{ etiquetaTipoReporte(tipo.clave) }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="incidencias-host-page__files" *ngIf="comentario.archivos?.length">
            <button type="button" *ngFor="let archivo of comentario.archivos" title="Abrir en una nueva pestaña" (click)="abrirArchivo(archivo)">
              <mat-icon>attach_file</mat-icon>
              <span>{{ archivo.nombreArchivo }}</span>
            </button>
          </div>
          <div class="incidencias-host-page__comment-actions" *ngIf="!soloLectura && puedeEditarComentario(comentario)">
            <button type="button" mat-button *ngIf="!comentario.editando" (click)="iniciarEdicionComentario(comentario, comentariosDetalle)">Editar</button>
            <button type="button" mat-button *ngIf="comentario.editando" [disabled]="faltaTipoAdicionalEdicion(comentario)"
              (click)="actualizarComentario(comentario)">Guardar</button>
          </div>
        </div>

        <div class="incidencias-host-page__new-comment" *ngIf="!soloLectura">
          <textarea maxlength="500" aria-label="Comentario" [(ngModel)]="nuevoComentarioPorDetalle[comentariosDetalle.idDetalleHost || 0]"
            placeholder="Comentario"></textarea>
          <div class="incidencias-host-page__tipo-adicional">
            <mat-checkbox [(ngModel)]="conTipoAdicionalPorDetalle[comentariosDetalle.idDetalleHost || 0]">Tipo adicional</mat-checkbox>
            <mat-form-field appearance="outline">
              <mat-label>Tipo de servicio</mat-label>
              <mat-select #nuevoComentarioTipoSelect [(ngModel)]="tipoAdicionalPorDetalle[comentariosDetalle.idDetalleHost || 0]"
                [disabled]="!conTipoAdicionalPorDetalle[comentariosDetalle.idDetalleHost || 0]"
                panelClass="incidencia-host-select-panel" (mousedown)="cerrarSelectSiAbierto($event, nuevoComentarioTipoSelect)">
                <mat-option *ngFor="let tipo of tiposReporteDisponibles" [value]="tipo.idTipoServicioHost">{{ etiquetaTipoReporte(tipo.clave) }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="incidencias-host-page__upload-row">
            <label class="incidencias-host-page__upload-button">
              <input type="file" multiple (change)="onFiles(comentariosDetalle, $event)" />
              <mat-icon>attach_file</mat-icon>
              <span>Elegir archivos</span>
            </label>
            <span class="incidencias-host-page__upload-status">{{ archivosDetalleLabel(comentariosDetalle) }}</span>
          </div>
          <div class="incidencias-host-page__new-comment-actions">
            <button type="button" mat-button class="btn btn-danger" (click)="cerrarComentarios()">
              <i class="fa fa-times-circle-o"></i> Cancelar
            </button>
            <button type="button" mat-button class="btn btn-success" [disabled]="faltaTipoAdicionalNuevo(comentariosDetalle)"
              (click)="guardarComentario(comentariosDetalle)">
              Comentar <i class="material-icons">send</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<div class="incidencias-host-modal-overlay incidencias-host-modal-overlay--third" *ngIf="fueraServicioResumenOpen" (click)="cerrarResumenFueraServicio()" (keydown.enter)="$event.target === $event.currentTarget ? cerrarResumenFueraServicio() : null">
  <section class="incidencias-host-secondary-modal incidencias-host-secondary-modal--wide" role="dialog" aria-modal="true"
    aria-label="Resumen de fuera de servicio" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <header class="incidencias-host-page__modal-header" [style.backgroundColor]="'#d97706'">
      <div class="incidencias-host-page__modal-title">
        <h3>
          <mat-icon>warning_amber</mat-icon>
          <span>Fuera de servicio</span>
        </h3>
        <p>Resumen del periodo y comentarios registrados.</p>
      </div>
      <button type="button" mat-icon-button (click)="cerrarResumenFueraServicio()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="incidencias-host-secondary-modal__body">
      <div class="incidencias-host-page__service-summary-header">
        <div>
          <h4>Periodo de fuera de servicio</h4>
          <p>Las fechas son editables; los comentarios se muestran solo como consulta.</p>
        </div>
        <strong [class.is-active]="form.fueraServicio">{{ form.fueraServicio ? "En curso" : "Finalizado" }}</strong>
      </div>

      <div class="incidencias-host-page__form-grid incidencias-host-page__form-grid--detail">
        <mat-form-field appearance="outline" class="incidencias-host-page__field--quarter incidencias-host-page__date-field">
          <mat-label>Fecha inicio fuera de servicio</mat-label>
          <input matInput aria-label="Fecha inicio fuera de servicio" [matDatepicker]="detallePickerFueraServicioInicio" [(ngModel)]="form.fechaFueraServicioInicio"
            [disabled]="soloLectura" (click)="toggleDatepicker(detallePickerFueraServicioInicio, $event)" />
          <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario" [disabled]="soloLectura"
            (click)="toggleDatepicker(detallePickerFueraServicioInicio, $event)">
            <mat-icon>calendar_today</mat-icon>
          </button>
          <mat-datepicker #detallePickerFueraServicioInicio panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="incidencias-host-page__field--quarter">
          <mat-label>Hora inicio fuera de servicio</mat-label>
          <input matInput aria-label="Hora inicio fuera de servicio" type="time" [(ngModel)]="formFechaFueraServicioInicioHora" [disabled]="soloLectura" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="incidencias-host-page__field--quarter incidencias-host-page__date-field">
          <mat-label>Fecha final fuera de servicio</mat-label>
          <input matInput aria-label="Fecha final fuera de servicio" [matDatepicker]="detallePickerFueraServicioFin" [(ngModel)]="form.fechaFueraServicioFin"
            [disabled]="soloLectura || form.fueraServicio" (click)="toggleDatepicker(detallePickerFueraServicioFin, $event)" />
          <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario" [disabled]="soloLectura || form.fueraServicio"
            (click)="toggleDatepicker(detallePickerFueraServicioFin, $event)">
            <mat-icon>calendar_today</mat-icon>
          </button>
          <mat-datepicker #detallePickerFueraServicioFin panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="incidencias-host-page__field--quarter">
          <mat-label>Hora final fuera de servicio</mat-label>
          <input matInput aria-label="Hora final fuera de servicio" type="time" [(ngModel)]="formFechaFueraServicioFinHora" [disabled]="soloLectura || form.fueraServicio" />
        </mat-form-field>
      </div>

      <div class="incidencias-host-page__service-summary-metric">
        <span>Tiempo acumulado</span>
        <strong>{{ tiempoFueraServicioVisible() }}</strong>
      </div>

      <div class="incidencias-host-page__service-comments">
        <h5>Comentarios durante fuera de servicio</h5>
        <div class="incidencias-host-page__service-comment" *ngFor="let comentario of comentariosFueraServicio(); trackBy: trackByComentario">
          <div>
            <div class="incidencias-host-page__service-comment-assignment">
              <span>Área: {{ areaComentario(comentario, detalleDelComentario(comentario)) }}</span>
              <span>Responsable: {{ responsableComentario(comentario, detalleDelComentario(comentario)) }}</span>
            </div>
            <span>{{ comentario.fechaModificacion | date: "dd/MM/yyyy HH:mm" }}</span>
          </div>
          <p>{{ comentario.comentario }}</p>
        </div>
        <p class="incidencias-host-page__service-comments-empty" *ngIf="!comentariosFueraServicio().length">
          No hay comentarios registrados dentro de este periodo.
        </p>
      </div>
    </div>

    <footer class="incidencias-host-secondary-modal__footer">
      <button mat-button class="btn btn-danger" type="button" (click)="cerrarResumenFueraServicio()">
        <i class="fa fa-times-circle-o"></i> Cerrar
      </button>
      <button mat-button type="button" class="btn btn-success" (click)="guardarResumenFueraServicio()" [disabled]="soloLectura">
        Guardar <i class="material-icons">save</i>
      </button>
    </footer>
  </section>
</div>

<div class="incidencias-host-modal-overlay incidencias-host-modal-overlay--third" *ngIf="transicionDialogOpen && selected" (click)="cerrarTransicionDialog()" (keydown.enter)="$event.target === $event.currentTarget ? cerrarTransicionDialog() : null">
  <section class="incidencias-host-secondary-modal" role="dialog" aria-modal="true"
    aria-label="Comentario de cambio de estado" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <header class="incidencias-host-page__modal-header" [style.backgroundColor]="estadoColor(selected.estadoEvento)">
      <div class="incidencias-host-page__modal-title">
        <h3>
          <mat-icon>published_with_changes</mat-icon>
          <span>{{ transicionObjetivo === 'PROCESO' && selected.estadoEvento === 'ATENDIDO' ? 'Regresar a proceso' : labelEstadoSiguiente(selected.estadoEvento) }}</span>
        </h3>
        <p>Agrega el comentario del movimiento.</p>
      </div>
      <button type="button" mat-icon-button (click)="cerrarTransicionDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="incidencias-host-secondary-modal__body incidencias-host-page__form-grid">
      <ng-container *ngIf="transicionObjetivo === 'PROCESO'">
        <mat-form-field appearance="outline" class="incidencias-host-page__field--half incidencias-host-page__date-field">
          <mat-label>Fecha inicio de atención</mat-label>
          <input matInput aria-label="Fecha inicio de atención" [matDatepicker]="transicionPickerInicioAtencion" [(ngModel)]="form.fechaInicioAtencion"
            (click)="toggleDatepicker(transicionPickerInicioAtencion, $event)" />
          <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario"
            (click)="toggleDatepicker(transicionPickerInicioAtencion, $event)">
            <mat-icon>calendar_today</mat-icon>
          </button>
          <mat-datepicker #transicionPickerInicioAtencion panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="incidencias-host-page__field--half">
          <mat-label>Hora inicio de atención</mat-label>
          <input matInput aria-label="Hora inicio de atención" type="time" [(ngModel)]="formFechaInicioAtencionHora" />
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="transicionObjetivo === 'ATENDIDO'">
        <mat-form-field appearance="outline" class="incidencias-host-page__field--half incidencias-host-page__date-field">
          <mat-label>Fecha fin</mat-label>
          <input matInput aria-label="Fecha fin" [matDatepicker]="transicionPickerFin" [(ngModel)]="form.fechaFin"
            (click)="toggleDatepicker(transicionPickerFin, $event)" />
          <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario"
            (click)="toggleDatepicker(transicionPickerFin, $event)">
            <mat-icon>calendar_today</mat-icon>
          </button>
          <mat-datepicker #transicionPickerFin panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="incidencias-host-page__field--half">
          <mat-label>Hora fin</mat-label>
          <input matInput aria-label="Hora fin" type="time" [(ngModel)]="formFechaFinHora" />
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="transicionObjetivo === 'VOBO'">
        <mat-form-field appearance="outline" class="incidencias-host-page__field--half incidencias-host-page__date-field">
          <mat-label>Fecha de confirmación de Vo.Bo</mat-label>
          <input matInput aria-label="Fecha de confirmación de Vo.Bo" [matDatepicker]="transicionPickerVobo" [(ngModel)]="fechaConfirmacionVobo"
            (click)="toggleDatepicker(transicionPickerVobo, $event)" />
          <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario"
            (click)="toggleDatepicker(transicionPickerVobo, $event)">
            <mat-icon>calendar_today</mat-icon>
          </button>
          <mat-datepicker #transicionPickerVobo panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="incidencias-host-page__field--half">
          <mat-label>Hora de confirmación de Vo.Bo</mat-label>
          <input matInput aria-label="Hora de confirmación de Vo.Bo" type="time" [(ngModel)]="horaConfirmacionVobo" />
        </mat-form-field>
      </ng-container>
      <mat-form-field appearance="outline" class="incidencias-host-page__transition-comment incidencias-host-page__textarea">
        <mat-label>Comentario</mat-label>
        <textarea matInput aria-label="Comentario" rows="4" [maxlength]="transicionObjetivo === 'VOBO' ? 450 : 500" [(ngModel)]="comentarioTransicion"></textarea>
      </mat-form-field>
      <div class="incidencias-host-page__file-field incidencias-host-page__transition-field" *ngIf="transicionObjetivo === 'VOBO'">
        <span>Evidencia</span>
        <div class="incidencias-host-page__upload-row">
          <label class="incidencias-host-page__upload-button">
            <input type="file" multiple (change)="onArchivosTransicion($event)" />
            <mat-icon>attach_file</mat-icon>
            <span>Elegir archivos</span>
          </label>
          <span class="incidencias-host-page__upload-status">{{ archivosTransicionLabel() }}</span>
        </div>
      </div>
    </div>

    <footer class="incidencias-host-secondary-modal__footer">
      <button mat-button class="btn btn-danger" type="button" (click)="cerrarTransicionDialog()">
        <i class="fa fa-times-circle-o"></i> Cancelar
      </button>
      <button mat-button type="button" class="btn btn-success" (click)="confirmarTransicion()">
        Aceptar <i class="material-icons">done</i>
      </button>
    </footer>
  </section>
</div>

<div class="incidencias-host-service-date-overlay" *ngIf="salidaServicioDialogOpen">
  <section class="incidencias-host-service-date-modal" role="dialog" aria-modal="true"
    aria-label="Fecha y hora de salida de servicio" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <header>
      <div>
        <h3>Salida de servicio</h3>
        <p>Fecha y hora en que se registró la salida de servicio.</p>
      </div>
      <button mat-icon-button type="button" aria-label="Cerrar" (click)="cancelarSalidaServicio()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="incidencias-host-service-date-modal__body">
      <mat-form-field appearance="outline" class="table-page__field incidencias-host-page__date-field">
        <mat-label>Fecha</mat-label>
        <input matInput aria-label="Fecha" [matDatepicker]="salidaServicioPicker" [(ngModel)]="salidaServicioFecha"
          (click)="toggleDatepicker(salidaServicioPicker, $event)" />
        <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario"
          (click)="toggleDatepicker(salidaServicioPicker, $event)">
          <mat-icon>calendar_today</mat-icon>
        </button>
        <mat-datepicker #salidaServicioPicker panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Hora</mat-label>
        <input matInput aria-label="Hora" type="time" [(ngModel)]="salidaServicioHora" />
      </mat-form-field>
    </div>

    <footer>
      <button mat-button class="btn btn-danger" type="button" (click)="cancelarSalidaServicio()">
        <i class="fa fa-times-circle-o"></i> Cancelar
      </button>
      <button mat-button type="button" class="btn btn-success" (click)="aceptarSalidaServicio()">
        Aceptar <i class="material-icons">done</i>
      </button>
    </footer>
  </section>
</div>

<ng-template #hostFormDialog>
  <div class="card incidencia-host-ticket-modal">
    <div class="card-header card-header-primary">
      <div class="row">
        <div class="col-sm-12 col-md-11">
          <h4 class="card-title">
            <b>{{ form.idIncidenciaHost ? "Editar incidencia Hosting" : "Nueva incidencia Hosting" }}</b>
          </h4>
          <p class="card-category">
            Registra el reporte de hosting, tiempos de atención y condiciones de servicio.
          </p>
        </div>
        <div class="col-sm-12 col-md-1 text-right">
          <button mat-icon-button type="button" aria-label="Cerrar" (click)="cerrarFormulario()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="wraper">
        <div class="container">
          <div class="incidencias-host-page__form-grid">
            <mat-form-field class="incidencias-host-page__field--quarter incidencias-host-page__date-field">
              <mat-label><b>Fecha inicio</b></mat-label>
              <input matInput aria-label="Fecha inicio" [matDatepicker]="pickerInicio" [(ngModel)]="form.fechaInicio"
                (click)="toggleDatepicker(pickerInicio, $event)" />
              <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario"
                (click)="toggleDatepicker(pickerInicio, $event)">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-datepicker #pickerInicio panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="incidencias-host-page__field--quarter">
              <mat-label><b>Hora inicio</b></mat-label>
              <input matInput aria-label="Hora inicio" type="time" [(ngModel)]="formFechaInicioHora" />
            </mat-form-field>

            <mat-form-field class="incidencias-host-page__field--quarter">
              <mat-label><b>Prioridad</b></mat-label>
              <mat-select #formPrioridadSelect [(ngModel)]="form.prioridad" [disabled]="form.fueraServicio" panelClass="incidencia-host-select-panel"
                (mousedown)="cerrarSelectSiAbierto($event, formPrioridadSelect)">
                <mat-option *ngFor="let option of prioridadOptions" [value]="option.value">{{ option.label }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="incidencias-host-page__field--quarter">
              <mat-label><b>N. severidad</b></mat-label>
              <mat-select #formSeveridadSelect [(ngModel)]="form.severidad" [disabled]="form.fueraServicio" panelClass="incidencia-host-select-panel"
                (mousedown)="cerrarSelectSiAbierto($event, formSeveridadSelect)">
                <mat-option *ngFor="let option of severidadOptions" [value]="option.value">{{ option.label }}</mat-option>
              </mat-select>
            </mat-form-field>

            <p class="incidencias-host-page__severity-text">{{ severidadDescripcion(form.severidad) }}</p>

            <mat-form-field *ngIf="mostrarFechaFinFormulario" class="incidencias-host-page__field--quarter incidencias-host-page__date-field">
              <mat-label><b>Fecha fin</b></mat-label>
              <input matInput aria-label="Fecha fin" [matDatepicker]="pickerFin" [(ngModel)]="form.fechaFin"
                (click)="toggleDatepicker(pickerFin, $event)" />
              <button mat-icon-button matSuffix type="button" aria-label="Abrir calendario"
                (click)="toggleDatepicker(pickerFin, $event)">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-datepicker #pickerFin panelClass="incidencia-host-datepicker-panel"></mat-datepicker>
            </mat-form-field>

            <mat-form-field *ngIf="mostrarFechaFinFormulario" class="incidencias-host-page__field--quarter">
              <mat-label><b>Hora fin</b></mat-label>
              <input matInput aria-label="Hora fin" type="time" [(ngModel)]="formFechaFinHora" />
            </mat-form-field>

            <mat-form-field class="incidencias-host-page__field--half">
              <mat-label><b>Cliente afectado</b></mat-label>
              <mat-select #formClienteSelect multiple [(ngModel)]="form.idsClientes"
                (ngModelChange)="onClientesFormularioChange($event)"
                (selectionChange)="cerrarClienteDespuesDeSeleccionar(formClienteSelect, $event)" [disabled]="clienteBloqueado()"
                [panelClass]="['incidencia-host-select-panel', 'incidencia-host-cliente-select-panel']"
                (mousedown)="cerrarSelectSiAbierto($event, formClienteSelect)">
                <mat-select-trigger>
                  {{ form.idsClientes?.length === clientes.length && clientes.length ? "Todos los clientes" : textoClientes() }}
                </mat-select-trigger>
                <mat-option [value]="clienteTodosValor">Todos los clientes</mat-option>
                <mat-option>
                  <ngx-mat-select-search [formControl]="busquedaClienteFormulario"
                    [placeholderLabel]="'Buscar cliente'" [noEntriesFoundLabel]="'No existe cliente'">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let cliente of clientesFormulario" [value]="cliente.id">
                  {{ cliente.razonsocial }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="clienteBloqueado()">El cliente queda fijo después de crear el ticket.</mat-hint>
            </mat-form-field>

            <mat-form-field class="incidencias-host-page__field--quarter">
              <mat-label><b>Tipo de reporte</b></mat-label>
              <mat-select #formTipoSelect [(ngModel)]="form.idTipoServicio" (ngModelChange)="onTipoServicioChange()" [disabled]="tipoReporteBloqueado()" panelClass="incidencia-host-select-panel"
                (mousedown)="cerrarSelectSiAbierto($event, formTipoSelect)">
                <mat-option *ngFor="let tipo of tiposReporteDisponibles" [value]="tipo.idTipoServicioHost">{{ etiquetaTipoReporte(tipo.clave) }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="incidencias-host-page__field--quarter">
              <mat-label><b>Área Coordinador</b></mat-label>
              <mat-select #formAreaResponsableSelect [(ngModel)]="form.idAreaResponsable"
                (selectionChange)="onAreaResponsableChange()" [disabled]="clienteBloqueado()"
                panelClass="incidencia-host-select-panel"
                (mousedown)="cerrarSelectSiAbierto($event, formAreaResponsableSelect)">
                <mat-option>
                  <ngx-mat-select-search [formControl]="busquedaAreaCoordinador"
                    [placeholderLabel]="'Buscar área'" [noEntriesFoundLabel]="'No existe área'">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let area of areasCoordinadorFiltradas" [value]="area.id">{{ area.area }}</mat-option>
              </mat-select>
              <mat-hint *ngIf="clienteBloqueado()">La asignación queda fija después de crear el ticket.</mat-hint>
            </mat-form-field>

            <mat-form-field class="incidencias-host-page__field--half">
              <mat-label><b>Coordinador</b></mat-label>
              <mat-select #formResponsableSelect [(ngModel)]="form.idEmpleadoResponsable"
                (selectionChange)="onResponsableActualChange()" [disabled]="clienteBloqueado()"
                panelClass="incidencia-host-select-panel"
                (mousedown)="cerrarSelectSiAbierto($event, formResponsableSelect)">
                <mat-option>
                  <ngx-mat-select-search [formControl]="busquedaCoordinador"
                    [placeholderLabel]="'Buscar coordinador'" [noEntriesFoundLabel]="'No hay coordinadores con perfil Host en esta área'">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let empleado of coordinadoresFiltrados" [value]="empleado.idEmpleado">
                  {{ nombreEmpleado(empleado) }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="clienteBloqueado()">La asignación queda fija después de crear el ticket.</mat-hint>
            </mat-form-field>

            <div class="incidencias-host-page__checkbox-row incidencias-host-page__field--quarter">
              <mat-checkbox [(ngModel)]="form.fueraServicio" (change)="onFueraServicioChange($event)">Fuera de servicio</mat-checkbox>
            </div>

            <div class="incidencias-host-page__field--quarter">
              <mat-form-field *ngIf="form.fueraServicio">
                <mat-label><b>Tiempo fuera de servicio (min)</b></mat-label>
                <input matInput aria-label="Tiempo fuera de servicio (min)" type="number" min="0" [(ngModel)]="form.tiempoFueraServicioMin" readonly />
              </mat-form-field>
            </div>

            <mat-form-field class="incidencias-host-page__textarea">
              <mat-label><b>Soporte</b></mat-label>
              <textarea matInput aria-label="Soporte" rows="4" maxlength="500" [(ngModel)]="form.soporte"></textarea>
            </mat-form-field>

            <div class="incidencias-host-page__checkbox-row">
              <mat-checkbox [(ngModel)]="form.requiereCambioHardware">Cambio de hardware</mat-checkbox>
            </div>

            <mat-form-field *ngIf="form.requiereCambioHardware">
              <mat-label><b>Equipo a reemplazar</b></mat-label>
              <input matInput aria-label="Equipo a reemplazar" maxlength="250" [(ngModel)]="form.equipoReemplazo" />
            </mat-form-field>
          </div>

          <div class="incidencias-host-page__computed" *ngIf="form.idIncidenciaHost">
            <span>Rango atención: <strong>{{ minutosLabel(form.rangoAtencionMin) }}</strong></span>
            <span>SLA atención: <strong>{{ form.slaAtencion === false ? "No" : "Sí" }}</strong></span>
            <span>SLA continuidad: <strong>{{ form.slaContinuidad | percent: "1.2-4" }}</strong></span>
          </div>

          <div mat-dialog-actions class="incidencias-host-page__actions">
            <button mat-button class="btn btn-danger" type="button" (click)="cerrarFormulario()">
              <i class="fa fa-times-circle-o"></i> Cancelar
            </button>
            <button mat-button type="button" (click)="guardarIncidencia()" class="btn btn-success">
              Guardar <i class="material-icons">save</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
